import { mutator } from 'satcheljs';
import { getStore as getLeftRailStore } from '../store/store';
import onOfficeAppClick from '../actions/onOfficeAppClick';
import onSelectOfficeRailApp from '../actions/onSelectOfficeRailApp';
import isSupportedOfficeRailApp from '../isSupportedOfficeRailApp';
import { onAppDrawerAppClick } from 'owa-app-drawer';
import { onOpenMOSAppWithContext } from 'owa-app-host-container';

mutator(onOfficeAppClick, actionMessage => {
    if (isSupportedOfficeRailApp(actionMessage.app)) {
        getLeftRailStore().selectedApp = actionMessage.app;
    }
});

mutator(onAppDrawerAppClick, actionMessage => {
    getLeftRailStore().selectedApp = actionMessage.appId;
});

mutator(onSelectOfficeRailApp, actionMessage => {
    getLeftRailStore().selectedApp = actionMessage.app;
});

mutator(onOpenMOSAppWithContext, actionMessage => {
    getLeftRailStore().selectedApp = actionMessage.appDefinition.appId;
});
